export const notificationReferenceTypes = {
  SUGGESTION_PDF_ARCHIVE_NOTIFICATION: '38',
};
